import { render, staticRenderFns } from "./ChatFavouriteUserMenu.vue?vue&type=template&id=316c6baa&"
import script from "./ChatFavouriteUserMenu.vue?vue&type=script&lang=js&"
export * from "./ChatFavouriteUserMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports